import bem from '../../../utils/bem';
import Icon from '../../Atoms/Icon/Icon';
import OptionsToggle from '../../Atoms/FormComponents/OptionsToggle';

const DisplaySwitcher = ({
  displaySwitcherState,
  setDisplaySwitcherState,
  displaySwitcherView,
  toggleData,
  mobileHidden = true,
}) => {
  if (!displaySwitcherState || !setDisplaySwitcherState) {
    return '';
  }

  return (
    <div
      className={bem('display-switcher', [], '', [
        mobileHidden ? 'hidden' : '',
      ])}
    >
      {displaySwitcherView === 'toggle' ? (
        <OptionsToggle
          {...toggleData}
          onOptionSelect={(v) => setDisplaySwitcherState(v)}
        />
      ) : (
        <>
          <button
            className={`btn-icon ${
              displaySwitcherState === 'list' ? 'active' : ''
            }`}
            onClick={() => setDisplaySwitcherState('list')}
          >
            <span className="visually-hidden">{Drupal.t('List view')}</span>
            <Icon iconName="list-view" />
          </button>

          <button
            className={`btn-icon ${
              displaySwitcherState === 'grid' ? 'active' : ''
            }`}
            onClick={() => setDisplaySwitcherState('grid')}
          >
            <span className="visually-hidden">{Drupal.t('Grid view')}</span>
            <Icon iconName="grid-view" />
          </button>
        </>
      )}
    </div>
  );
};

export default DisplaySwitcher;
